function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M12.71,6.15H10.65V4.09a4.1,4.1,0,0,0-8.19,0V6.15H.4a.4.4,0,0,0-.4.4V16.4a.4.4,0,0,0,.4.4H12.71a.4.4,0,0,0,.4-.4V6.55A.4.4,0,0,0,12.71,6.15ZM3.26,4.09a3.3,3.3,0,0,1,6.59,0V6.15H3.26ZM12.31,16H.8V7H12.31ZM7,11.37a.43.43,0,0,1,0,.11v2.46a.4.4,0,0,1-.8,0V11.48a.43.43,0,0,1,0-.11.81.81,0,0,1-.45-.72.83.83,0,1,1,1.66,0A.81.81,0,0,1,7,11.37Z"
})));

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 13.11 16.8",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.a16b63b6.svg";
export { ForwardRef as ReactComponent };